import { render, staticRenderFns } from "./MasterDosen.vue?vue&type=template&id=52b99e4e"
import script from "./MasterDosen.vue?vue&type=script&lang=js"
export * from "./MasterDosen.vue?vue&type=script&lang=js"
import style0 from "./MasterDosen.vue?vue&type=style&index=0&id=52b99e4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports